import { IsBoolean, IsString } from 'class-validator';

export class AdminWorkspacesCleanupDto {
  @IsBoolean()
  dryRun: boolean;

  @IsString()
  repoFilter: string;
}
